<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-bodymatter element-type-prologue element-with-heading" id="prologue">
<div class="heading heading-with-title heading-without-image" id="prologue-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Prologue</h1>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">N</span>one of them would ever know <i>when</i> it all began. Human memory doesn’t reach that far back. Recorded history has its limits. Time is a veil not easily pierced.</p>
<p class="subsq"><i>Where</i> it began? That’s another story. It began on the river, always on the river. This, everyone could see. Rivers take the long view, and the marks they carve into the earth survive the ages.</p>
<p class="subsq">Every ripple, every riffle, every eddy, each rush of wild whitewater over rocks or between towering limestone walls, every still-seeming pool hiding quick currents, all these aspects of the river exist in the now but hold the memory of eons gone by, and at night the river whispers or roars or babbles its secret memories to those who know how to listen.</p>
<p class="subsq">The river is at fault, yet blameless. The river doesn’t choose sides or hold grudges.</p>
<p class="subsq">But the river remembers.…</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?02f7e947